import { NativeStackHeaderProps } from '@react-navigation/native-stack';
import {
  BottomSheetComponent,
  NavigationConfig,
  ParamListBase,
  registerBottomSheets,
  hideHeader,
  Header,
  Modal,
  registerModals,
  registerNavigationHandlers,
  Route,
} from '@betty/navigation';
import { Box } from '@betty/moonlight';
import {
  DepositCompleted,
  WithdrawalCompleted,
  DepositAmount,
  DepositPromoInfo,
  DepositNoPromo,
  DepositInterac,
  WithdrawInterac,
  WithdrawConfirmation,
  WithdrawEmailStatus,
  WithdrawEmailVerification,
  WithdrawInsufficientFunds,
} from '../bottomSheets';
import DepositNavigator from '../navigators/DepositNavigator/DepositNavigator';
import WithdrawNavigator from '../navigators/WithdrawNavigator/WithdrawNavigator';
import PaymentMethodVerificationNavigator from '../navigators/PaymentMethodVerificationNavigator/PaymentMethodVerificationNavigator';
import CashBalanceHeaderItem from '../components/CashBalanceHeaderItem/CashBalanceHeaderItem';
import {
  ComponentProps,
  FunctionComponent,
  JSXElementConstructor,
} from 'react';
import { DepositNavigatorParamsList } from '../navigators/DepositNavigator/DepositNavigator.types';
import PaymentStatusScreen from '../screens/PaymentStatusScreen/PaymentStatusScreen';

export const NAVIGATION_CONFIG: NavigationConfig<AppNavigatorParamsList> = {
  FULL_SCREEN_MODALS_TRANSPARENT: [],
  FULL_SCREENS: [
    {
      name: 'PaymentStatusScreen',
      options: {},
      component: PaymentStatusScreen as FunctionComponent<{
        route: Route<string, object | undefined>;
      }>,
    },
  ],
  FULL_SCREEN_MODALS: [
    {
      name: 'Deposit',
      options: hideHeader,
      component: DepositNavigator,
    },
    {
      name: 'Withdraw',
      options: hideHeader,
      component: WithdrawNavigator as never, // TODO: fix TS
    },
    {
      name: 'PaymentMethodVerification',
      options: hideHeader,
      component: PaymentMethodVerificationNavigator as never, // TODO: fix TS
    },
  ],
};

export const PAYMENT_SCREEN_OPTIONS = {
  header: (props: NativeStackHeaderProps) => (
    <Header
      headerRight={
        <Box padding="space-200">
          <CashBalanceHeaderItem disableNavigation />
        </Box>
      }
      {...props}
    />
  ),
};

const bottomSheets = {
  WithdrawalCompleted,
  DepositCompleted,
  DepositAmount,
  DepositPromoInfo,
  DepositNoPromo,
  DepositInterac,
  WithdrawInterac,
  WithdrawConfirmation,
  WithdrawEmailStatus,
  WithdrawEmailVerification,
  WithdrawInsufficientFunds,
};

registerBottomSheets('wallet', bottomSheets);

declare global {
  interface AppNavigatorParamsList extends ParamListBase {
    Deposit: undefined;
    Withdraw: undefined;
    PaymentMethodVerification?: {
      paymentEntityId?: number;
    };
  }

  interface RegisteredBottomSheets {
    wallet: Record<keyof typeof bottomSheets, BottomSheetComponent>;
  }
}

const modals = {
  Deposit: DepositNavigator,
  Withdraw: WithdrawNavigator,
  PaymentMethodVerification: PaymentMethodVerificationNavigator,
};

registerModals('wallet', modals);

declare global {
  interface RegisteredModals {
    wallet: {
      [K in keyof typeof modals]: JSXElementConstructor<
        ComponentProps<(typeof modals)[K]>
      >;
    };
  }
}

const WALLET_MODAL_CONFIG = {
  isProtected: true,
  options: {
    hideHeader: true,
  },
  style: {
    width: '100%',
    maxWidth: 720,
    height: { mobile: '100%', tablet: 700, desktop: 700 },
    paddingTop: 'space-200',
  },
} as const;

registerNavigationHandlers<
  AppNavigatorParamsList,
  'Deposit' | 'Withdraw' | 'PaymentMethodVerification'
>({
  Deposit() {
    Modal.open({
      namespace: 'wallet',
      type: 'Deposit',
      ...WALLET_MODAL_CONFIG,
    });
  },
  Withdraw() {
    Modal.open({
      namespace: 'wallet',
      type: 'Withdraw',
      ...WALLET_MODAL_CONFIG,
    });
  },
  PaymentMethodVerification(_, params) {
    Modal.close().then(() => {
      Modal.open({
        namespace: 'wallet',
        type: 'PaymentMethodVerification',
        data: {
          route: { params },
        },
        ...WALLET_MODAL_CONFIG,
      });
    });
  },
});

registerNavigationHandlers<
  DepositNavigatorParamsList,
  'DepositInteracURLScreen'
>({
  DepositInteracURLScreen(_, params) {
    if (params) {
      window.open(window.location.origin, '_blank');
    }
  },
});
